export enum RoundingMode {
  Ceil = 0,
  Floor = 1,
}
